import React, { memo } from 'react';

const PlayButtonIcon = memo(props => {
  const { style, className } = props;
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={style} className={className}>
      <path
        d="M18.8136 10.9707C19.3876 11.3684 19.3876 12.217 18.8136 12.6147L6.56949 21.0976C5.90629 21.5571 5 21.0824 5 20.2756L5 3.30976C5 2.50294 5.90629 2.02829 6.5695 2.48777L18.8136 10.9707Z"
        fill="white"
      />
    </svg>
  );
});

const VolumeIcon = memo(props => {
  const { style, className } = props;
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={style} className={className}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4286 7.05266C13.4286 6.21415 12.4586 5.74798 11.8039 6.27179L7.9882 9.32433C7.81089 9.46618 7.59058 9.54346 7.3635 9.54346H3C2.44772 9.54346 2 9.99118 2 10.5435V15.4006C2 15.9529 2.44772 16.4006 3 16.4006H7.3635C7.59058 16.4006 7.81089 16.4779 7.9882 16.6197L11.8039 19.6723C12.4586 20.1961 13.4286 19.7299 13.4286 18.8914V7.05266Z"
        fill="white"
      />
      <path
        d="M16 11.0508C16 11.0508 16.5 11.8008 16.5 13.0508C16.5 14.3008 16 15.0508 16 15.0508"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M19 7.05078C19 7.05078 21 9.30077 21 13.0508C21 16.8007 19 19.0508 19 19.0508"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
});

const DownloadIcon = memo(props => {
  const { style, className } = props;
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.4 12.7998L16 17.9998L21.6 12.7998" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 5.6001V17.6001" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" />
      <path
        d="M6.40002 19.2002V22.8002C6.40002 23.9048 7.29545 24.8002 8.40002 24.8002H23.6C24.7046 24.8002 25.6 23.9048 25.6 22.8002V19.2002"
        stroke="#FFFFFF"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
});

const FullscreenIcon = memo(props => {
  const { style, className } = props;
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" style={style} className={className}>
      <path
        d="M3.17025 20.9528C2.78496 21.3485 2.79341 21.9816 3.1891 22.3669C3.5848 22.7521 4.21791 22.7437 4.60319 22.348L3.17025 20.9528ZM6.5183 18.9477L5.81878 18.2331C5.81306 18.2387 5.80741 18.2443 5.80183 18.2501L6.5183 18.9477ZM10.5862 16.365C10.9809 15.9787 10.9877 15.3455 10.6013 14.9509C10.215 14.5562 9.58187 14.5494 9.1872 14.9358L10.5862 16.365ZM4.60319 22.348L7.23477 19.6453L5.80183 18.2501L3.17025 20.9528L4.60319 22.348ZM7.21782 19.6623L10.5862 16.365L9.1872 14.9358L5.81878 18.2331L7.21782 19.6623Z"
        fill="white"
      />
      <path
        d="M22.6032 4.34801C22.9885 3.95231 22.98 3.3192 22.5843 2.93392C22.1886 2.54864 21.5555 2.55708 21.1702 2.95277L22.6032 4.34801ZM19.2551 6.35309L19.9547 7.0677C19.9604 7.06211 19.966 7.05644 19.9716 7.05071L19.2551 6.35309ZM15.1872 8.93578C14.7925 9.32212 14.7858 9.95524 15.1721 10.3499C15.5584 10.7446 16.1916 10.7513 16.5862 10.365L15.1872 8.93578ZM21.1702 2.95277L18.5387 5.65548L19.9716 7.05071L22.6032 4.34801L21.1702 2.95277ZM18.5556 5.63848L15.1872 8.93578L16.5862 10.365L19.9547 7.0677L18.5556 5.63848Z"
        fill="white"
      />
      <path
        d="M8.88672 22.6504C9.439 22.6504 9.88672 22.2027 9.88672 21.6504C9.88672 21.0981 9.439 20.6504 8.88672 20.6504L8.88672 22.6504ZM3.88672 21.6504L2.88672 21.6504C2.88672 22.2027 3.33443 22.6504 3.88672 22.6504L3.88672 21.6504ZM4.88672 16.6504C4.88672 16.0981 4.439 15.6504 3.88672 15.6504C3.33443 15.6504 2.88672 16.0981 2.88672 16.6504L4.88672 16.6504ZM8.88672 20.6504L3.88672 20.6504L3.88672 22.6504L8.88672 22.6504L8.88672 20.6504ZM4.88672 21.6504L4.88672 16.6504L2.88672 16.6504L2.88672 21.6504L4.88672 21.6504Z"
        fill="white"
      />
      <path
        d="M16.8867 2.65039C16.3344 2.65039 15.8867 3.09811 15.8867 3.65039C15.8867 4.20268 16.3344 4.65039 16.8867 4.65039L16.8867 2.65039ZM21.8867 3.65039L22.8867 3.65039C22.8867 3.09811 22.439 2.65039 21.8867 2.65039L21.8867 3.65039ZM20.8867 8.65039C20.8867 9.20268 21.3344 9.65039 21.8867 9.65039C22.439 9.65039 22.8867 9.20268 22.8867 8.65039L20.8867 8.65039ZM16.8867 4.65039L21.8867 4.65039L21.8867 2.65039L16.8867 2.65039L16.8867 4.65039ZM20.8867 3.65039L20.8867 8.65039L22.8867 8.65039L22.8867 3.65039L20.8867 3.65039Z"
        fill="white"
      />
    </svg>
  );
});

const CloseFullScreenIcon = memo(props => {
  const { style, className } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" fill="none">
      <rect width="100%" height="100%" x="0" y="0" fill="#fff" fillOpacity="0" stroke="none"></rect>
      <g fill="#fff" className="currentLayer">
        <path d="M7.17 24.877a1 1 0 101.433 1.395L7.17 24.877zm3.348-2.005l-.7-.715a1.132 1.132 0 00-.017.017l.717.698zm4.068-2.583a1 1 0 00-1.4-1.43l1.4 1.43zm-5.983 5.983l2.631-2.703-1.433-1.395-2.631 2.703 1.433 1.395zm2.614-2.686l3.369-3.297-1.4-1.43-3.368 3.298 1.4 1.43z"></path>
        <path d="M26.603 8.272a1 1 0 10-1.433-1.395l1.433 1.395zm-3.348 2.005l.7.715a.677.677 0 00.016-.018l-.716-.697zm-4.068 2.583a1 1 0 001.399 1.429l-1.4-1.43zm5.983-5.983l-2.632 2.702 1.433 1.396 2.632-2.703-1.433-1.395zm-2.615 2.685l-3.368 3.298 1.399 1.429 3.368-3.297-1.399-1.43z"></path>
        <path d="M23.662 15.799a1 1 0 000-2v2zm-5-1h-1a1 1 0 001 1v-1zm1-5a1 1 0 10-2 0h2zm4 4h-5v2h5v-2zm-4 1v-5h-2v5h2z"></path>
        <path d="M10.274 17.513a1 1 0 100 2v-2zm5 1h1a1 1 0 00-1-1v1zm-1 5a1 1 0 102 0h-2zm-4-4h5v-2h-5v2zm4-1v5h2v-5h-2z"></path>
      </g>
    </svg>
  );
});

const MuteIcon = memo(props => {
  const { style, className } = props;
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={style} className={className}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4286 6.40227C13.4286 5.56376 12.4586 5.09759 11.8039 5.6214L7.9882 8.67394C7.81089 8.81579 7.59058 8.89307 7.3635 8.89307H3C2.44772 8.89307 2 9.34079 2 9.89307V14.7502C2 15.3025 2.44772 15.7502 3 15.7502H7.3635C7.59058 15.7502 7.81089 15.8275 7.9882 15.9693L11.8039 19.0219C12.4586 19.5457 13.4286 19.0795 13.4286 18.241V6.40227Z"
        fill="white"
      />
      <path d="M16 10L20 14" stroke="white" strokeWidth="2" strokeLinecap="round" />
      <path d="M20 10L16 14" stroke="white" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
});

const PauseIcon = memo(props => {
  const { style, className } = props;
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" style={style} className={className}>
      <rect x="4" y="3.05078" width="4" height="19" rx="2" fill="white" />
      <rect x="16" y="3.05078" width="4" height="19" rx="2" fill="white" />
    </svg>
  );
});

const RoundedPlayIcon = memo(props => {
  const { style, className, ...rest } = props;
  return (
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
      <circle cx="40" cy="40" r="40" fill="black" fillOpacity="0.8" />
      <circle cx="40" cy="40" r="39.5" stroke="white" strokeOpacity="0.6" />
      <path
        d="M53.8136 39.1782C54.3876 39.5759 54.3876 40.4245 53.8136 40.8222L31.5695 56.2333C30.9063 56.6928 30 56.2181 30 55.4113L30 24.5891C30 23.7822 30.9063 23.3076 31.5695 23.7671L53.8136 39.1782Z"
        fill="white"
      />
    </svg>
  );
});

const TurnOnSubtitlesIcon = memo(props => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.207 9H7C5.34315 9 4 10.3431 4 12V28C4 29.6569 5.34315 31 7 31H33C34.6569 31 36 29.6569 36 28V15.793C35.5232 15.9278 35.02 16 34.5 16C34.3315 16 34.1647 15.9924 34 15.9776V28C34 28.5523 33.5523 29 33 29H7C6.44772 29 6 28.5523 6 28V12C6 11.4477 6.44772 11 7 11H29.0224C29.0076 10.8353 29 10.6685 29 10.5C29 9.97999 29.0722 9.47683 29.207 9Z"
        fill="white"
      />
      <path d="M32 8L37 13" stroke="white" strokeWidth="2" strokeLinecap="round" />
      <path d="M37 8L32 13" stroke="white" strokeWidth="2" strokeLinecap="round" />
      <path
        d="M18.5 22C18.5 22 18 23 16.5 23C15 23 14 22.0001 14 20C14 18 15 17 16.5 17C18 17 18.5 18 18.5 18"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M26.5 22C26.5 22 26 23 24.5 23C23 23 22 22.0001 22 20C22 18 23 17 24.5 17C26 17 26.5 18 26.5 18"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
});

const NoSubtitlesIcon = memo(props => {
  return (
    <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.8864 15.3672V24.4973C35.8864 27.2587 33.6478 29.4973 30.8864 29.4973H27.9471L20.3308 34.1328V29.4973H10.8848C8.12205 29.4973 5.88635 27.2574 5.88635 24.4973V13.5742C5.88635 10.8128 8.12493 8.57422 10.8864 8.57422H29.0934C28.9585 9.05105 28.8864 9.55421 28.8864 10.0742C28.8864 10.2428 28.8939 10.4095 28.9088 10.5742H10.8864C9.2295 10.5742 7.88635 11.9174 7.88635 13.5742V24.4973C7.88635 26.1542 9.22796 27.4973 10.8848 27.4973H22.3308V30.5742L27.3864 27.4973H30.8864C32.5432 27.4973 33.8864 26.1541 33.8864 24.4973V15.5518C34.051 15.5666 34.2178 15.5742 34.3864 15.5742C34.9064 15.5742 35.4095 15.5021 35.8864 15.3672Z"
        fill="white"
      />
      <path d="M31.8864 7.57422L36.8864 12.5742" stroke="#CB0000" strokeWidth="2" strokeLinecap="round" />
      <path d="M36.8864 7.57422L31.8864 12.5742" stroke="#CB0000" strokeWidth="2" strokeLinecap="round" />
      <path d="M10.8864 16.5742H22.8864" stroke="white" strokeWidth="2" strokeLinecap="round" />
      <path d="M22.3864 20.5742H30.3864" stroke="white" strokeWidth="2" strokeLinecap="round" />
      <path d="M27.3864 16.5742H30.3864" stroke="white" strokeWidth="2" strokeLinecap="round" />
      <path d="M11.3864 20.5742H18.3864" stroke="white" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
});

const SubtitlesExistIcon = memo(props => {
  return (
    <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.8862 15.3672V24.4973C35.8862 27.2587 33.6477 29.4973 30.8862 29.4973H27.947L20.3307 34.1328V29.4973H10.8847C8.12193 29.4973 5.88623 27.2574 5.88623 24.4973V13.5742C5.88623 10.8128 8.12481 8.57422 10.8862 8.57422H29.0933C28.9584 9.05105 28.8862 9.55421 28.8862 10.0742C28.8862 10.2428 28.8938 10.4095 28.9087 10.5742H10.8862C9.22938 10.5742 7.88623 11.9174 7.88623 13.5742V24.4973C7.88623 26.1542 9.22784 27.4973 10.8847 27.4973H22.3307V30.5742L27.3862 27.4973H30.8862C32.5431 27.4973 33.8862 26.1541 33.8862 24.4973V15.5518C34.0509 15.5666 34.2177 15.5742 34.3862 15.5742C34.9062 15.5742 35.4094 15.5021 35.8862 15.3672Z"
        fill="white"
      />
      <path
        d="M31.8862 10.1742L34.1362 12.5742L37.8862 8.57422"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10.8862 16.5742H22.8862" stroke="white" strokeWidth="2" strokeLinecap="round" />
      <path d="M22.3862 20.5742H30.3862" stroke="white" strokeWidth="2" strokeLinecap="round" />
      <path d="M27.3862 16.5742H30.3862" stroke="white" strokeWidth="2" strokeLinecap="round" />
      <path d="M11.3862 20.5742H18.3862" stroke="white" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
});

const BackwardIcon = memo(props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 5C12.5 4.44772 12.9477 4 13.5 4H15C19.9706 4 24 8.02944 24 13C24 17.9706 19.9706 22 15 22C14.4477 22 14 21.5523 14 21C14 20.4477 14.4477 20 15 20C18.866 20 22 16.866 22 13C22 9.13401 18.866 6 15 6H13.5C12.9477 6 12.5 5.55228 12.5 5Z"
        fill="white"
      />
      <path
        d="M4.3 16.048C4.828 16.048 5.292 16.164 5.692 16.396C6.1 16.62 6.412 16.936 6.628 17.344C6.852 17.752 6.964 18.22 6.964 18.748C6.964 19.308 6.836 19.8 6.58 20.224C6.324 20.648 5.96 20.976 5.488 21.208C5.024 21.44 4.476 21.556 3.844 21.556C3.316 21.556 2.792 21.468 2.272 21.292C1.76 21.108 1.336 20.868 1 20.572L1.516 19.444C2.284 20.028 3.068 20.32 3.868 20.32C4.396 20.32 4.8 20.188 5.08 19.924C5.36 19.66 5.5 19.284 5.5 18.796C5.5 18.324 5.356 17.952 5.068 17.68C4.788 17.4 4.404 17.26 3.916 17.26C3.588 17.26 3.276 17.324 2.98 17.452C2.692 17.572 2.432 17.748 2.2 17.98H1.276V13H6.58V14.2H2.788V16.48C3.196 16.192 3.7 16.048 4.3 16.048Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7071 0.292893C17.0976 0.683417 17.0976 1.31658 16.7071 1.70711L13.4142 5L16.7071 8.29289C17.0976 8.68342 17.0976 9.31658 16.7071 9.70711C16.3166 10.0976 15.6834 10.0976 15.2929 9.70711L11.2929 5.70711C10.9024 5.31658 10.9024 4.68342 11.2929 4.29289L15.2929 0.292893C15.6834 -0.0976311 16.3166 -0.0976311 16.7071 0.292893Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7071 0.292893C12.0976 0.683417 12.0976 1.31658 11.7071 1.70711L8.41421 5L11.7071 8.29289C12.0976 8.68342 12.0976 9.31658 11.7071 9.70711C11.3166 10.0976 10.6834 10.0976 10.2929 9.70711L6.29289 5.70711C5.90237 5.31658 5.90237 4.68342 6.29289 4.29289L10.2929 0.292893C10.6834 -0.0976311 11.3166 -0.0976311 11.7071 0.292893Z"
        fill="white"
      />
    </svg>
  );
});

const ForwardIcon = memo(props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 5C12 4.44772 11.5523 4 11 4H9.5C4.52944 4 0.5 8.02944 0.5 13C0.5 17.9706 4.52944 22 9.5 22C10.0523 22 10.5 21.5523 10.5 21C10.5 20.4477 10.0523 20 9.5 20C5.63401 20 2.5 16.866 2.5 13C2.5 9.13401 5.63401 6 9.5 6H11C11.5523 6 12 5.55228 12 5Z"
        fill="white"
      />
      <path
        d="M20.3 16.048C20.828 16.048 21.292 16.164 21.692 16.396C22.1 16.62 22.412 16.936 22.628 17.344C22.852 17.752 22.964 18.22 22.964 18.748C22.964 19.308 22.836 19.8 22.58 20.224C22.324 20.648 21.96 20.976 21.488 21.208C21.024 21.44 20.476 21.556 19.844 21.556C19.316 21.556 18.792 21.468 18.272 21.292C17.76 21.108 17.336 20.868 17 20.572L17.516 19.444C18.284 20.028 19.068 20.32 19.868 20.32C20.396 20.32 20.8 20.188 21.08 19.924C21.36 19.66 21.5 19.284 21.5 18.796C21.5 18.324 21.356 17.952 21.068 17.68C20.788 17.4 20.404 17.26 19.916 17.26C19.588 17.26 19.276 17.324 18.98 17.452C18.692 17.572 18.432 17.748 18.2 17.98H17.276V13H22.58V14.2H18.788V16.48C19.196 16.192 19.7 16.048 20.3 16.048Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2929 0.292893C11.9024 0.683417 11.9024 1.31658 12.2929 1.70711L15.5858 5L12.2929 8.29289C11.9024 8.68342 11.9024 9.31658 12.2929 9.70711C12.6834 10.0976 13.3166 10.0976 13.7071 9.70711L17.7071 5.70711C18.0976 5.31658 18.0976 4.68342 17.7071 4.29289L13.7071 0.292893C13.3166 -0.0976311 12.6834 -0.0976311 12.2929 0.292893Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.29289 0.292893C6.90237 0.683417 6.90237 1.31658 7.29289 1.70711L10.5858 5L7.29289 8.29289C6.90237 8.68342 6.90237 9.31658 7.29289 9.70711C7.68342 10.0976 8.31658 10.0976 8.70711 9.70711L12.7071 5.70711C13.0976 5.31658 13.0976 4.68342 12.7071 4.29289L8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893Z"
        fill="white"
      />
    </svg>
  );
});

export {
  PlayButtonIcon,
  VolumeIcon,
  FullscreenIcon,
  CloseFullScreenIcon,
  DownloadIcon,
  MuteIcon,
  PauseIcon,
  RoundedPlayIcon,
  TurnOnSubtitlesIcon,
  NoSubtitlesIcon,
  SubtitlesExistIcon,
  BackwardIcon,
  ForwardIcon,
};
